<template>
    <div class="block-item p-3">
      <div class="d-flex align-items-center">
          <img :src="`${publicPath}/img/rcp/master-card-prepaid.svg`" width="50px">
          <div class="px-3 d-flex flex-column">
              <div class="fz-20 fw-700">{{ $t(data.name) }}</div>
              <div class="fz-14 fw-400">Most Popular</div>
          </div>
      </div>
      <hr>
      <img :src="data.image" width="100%"/>
      <div class="fz-20 fw-700 mb-3 text-center">Card Fee <span class="text-orange">USD ${{ data.card_fee }}</span></div>
      <h6 class="desc mb-4"> {{ $t(data.description) }} </h6>
      <div class="fz-16 fw-600 mb-3">Benefits</div>
      <div class="d-flex fz-14 fw-400 align-items-center mb-3">
        <img :src="`${publicPath}/img/rcp/tick-circle.svg`" style="width: 25px;margin-right: 5px;">
        <span>Can be used in over 210 countries and territories with Mastercard Contractless Payment.</span>
      </div>
      <div class="d-flex fz-14 fw-400 align-items-center mb-3">
        <img :src="`${publicPath}/img/rcp/tick-circle.svg`" style="width: 25px;margin-right: 5px;">
        <span>No need for Credit Background Check, suitable for all types of people.</span>
      </div>
      <div class="d-flex fz-14 fw-400 align-items-center mb-4">
        <img :src="`${publicPath}/img/rcp/tick-circle.svg`" style="width: 25px;margin-right: 5px;">
        <span>Finish the eKYC and Apply the Card in 5 mins!</span>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-secondary w-100" block>{{ $t('Details') }}</button>
        <button class="btn btn-orange w-100" block :disabled="data.is_disabled" @click="$router.push({ name: 'fill-in-details',params: { data }});">{{ $t(data.button) }}</button>
      </div>
    </div>
    <!-- <div class="physical-card">
        <b-row class="justify-content-end">
            <div class="label-card">
            <div class="">{{ $t(data.type) }}</div>
            </div>
        </b-row>
        <div class="d-block d-md-flex align-items-center mt-3">
            <img :src="data.image" width="244px"/>
            <div>
            <h3>{{ $t(data.name) }} </h3>
            <p v-if="data.card_fee>0">{{ data.card_fee }} <small v-if="data.currency">{{ data.currency }}</small></p>
            </div>
        </div>
        <h6 class="desc"> {{ $t(data.description) }} </h6>
        <button 
        @click="$router.push({ name: 'fill-in-details',params: { data }});"
        :disabled="data.is_disabled"
        >{{ $t(data.button) }} </button>
    </div> -->
</template>
  
  <script>
    export default {
      data() {
        return {
          publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        }
      },
      components:{
          
      },
      props:['data'],
      methods:{
        
      }
    }
  </script>